//
import Service from '@/services/api/service'
import SlCheckMdl from '@/models/Sale/SlCheck'

//
//import filters from './filters'
import headers from './headers'

//
export default class extends Service {

    //
    static filters  = []
    static headers  = headers
    static includes = [
        'g_bank',
        'pos_payment_check_type',
        'sl_check_status',
    ]
    
    //
    static model = SlCheckMdl

    
}
